module.exports = __webpack_public_path__ + "img/pasture_high.6309e63d.jpg";